import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getTimeInfoUi } from '../../../../../helpers/jobs';
import { monthDayYearFullFormat } from '../../../../../constants/date';
import { formatPrice } from '../../../../../helpers/formatData';
import WorkersPreviewPhotosList from '../../../jobDetails/TipsAndRates/WorkersPreviewPhotosList';

export default class JobInfo extends Component {
  static propTypes = {
    isSummaryStep: PropTypes.bool,
    jobData: PropTypes.shape({
      start: PropTypes.object.isRequired,
      startTime: PropTypes.object.isRequired,
      endTime: PropTypes.object.isRequired,
      hours: PropTypes.number.isRequired,
      quantityOfWorkers: PropTypes.number.isRequired
    }),
    selectedWorkersInfoIsShown: PropTypes.bool.isRequired,
    editJob: PropTypes.func,
    deleteJobFromList: PropTypes.func
  };

  render () {
    const { jobData, editJob, deleteJobFromList, isSummaryStep, selectedWorkersInfoIsShown } = this.props;
    const { id, start, startTime, endTime, quantityOfWorkers, hours, estCost, selectedWorkers } = jobData;
    const jobDate = start.format(monthDayYearFullFormat);
    const timeShiftUI = getTimeInfoUi(startTime, endTime, hours);
    return (
      <div className='scheduled-job row mb-3 mb-lg-2'>
        <div className={`col-12 col-sm-6 col-md-3 ${isSummaryStep ? 'col-lg-3 col-xl-3' : 'col-lg-2 col-xl-2'}  mb-1`}>{ jobDate }</div>
        <div className={`col-12 col-sm-6 ${isSummaryStep ? 'col-md-5' : 'col-md-3'}   mb-1`}>
          <p>{ timeShiftUI }</p>
          <p className='text-muted'>Time</p>
        </div>
        <div className={`col-6 ${isSummaryStep ? 'col-sm-6' : 'col-sm-3'} col-md-2 mb-1 workers-quantity-info position-relative ${selectedWorkers.length > 0 ? 'pointer' : ''}`}>
          <p>{ selectedWorkersInfoIsShown ? `${selectedWorkers.length}/${quantityOfWorkers}` : quantityOfWorkers }</p>
          <p className='text-muted'>Workers</p>
          { selectedWorkers.length > 0 && (
            <div className='popupMenu'>
              <WorkersPreviewPhotosList
                selectedWorkers={selectedWorkers}
                shownPhotosQuantity={3}
              />
            </div>
          )}
        </div>
        <div className={`col-6 ${isSummaryStep ? 'col-sm-6' : 'col-sm-3'} col-md-2 mb-1`}>
          <p>{ formatPrice(estCost) }</p>
          <p className='text-muted'>Est. Pay</p>
        </div>
        { !isSummaryStep && (
          <React.Fragment>
            <div className='col-6 col-sm-3 col-md-1 col-lg-2 col-xl-2'>
              <button
                className='non-button px-0 delete mb-1'
                onClick={() => deleteJobFromList(id)}
              >Delete</button>
            </div>
            <div className='col-6 col-sm-3 col-md-1 col-lg-1 col-xl-1 pl-lg-0 mb-1'>
              <button
                className='non-button px-0 edit'
                onClick={() => editJob(jobData)}
              >Edit</button>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/LocationScheduleStep/JobInfo.js